import React from "react";
import { highlights, profile } from "../data";

export default function About() {
  return (
    <section id="about" className="pt-14">
      <div className="relative overflow-hidden rounded-3xl border border-fuchsia-400/20 bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-950 p-8 shadow-2xl shadow-fuchsia-900/20 md:p-12">
        <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-pink-500/20 blur-3xl" />
        <div className="absolute -bottom-24 -right-20 h-72 w-72 rounded-full bg-cyan-500/20 blur-3xl" />
        <div className="mb-10 flex flex-col gap-8 lg:flex-row lg:items-end">
          <div className="relative lg:w-3/4">
            <p className="mb-4 inline-flex rounded-full border border-pink-400/40 bg-pink-500/20 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-pink-100">
              Open to impactful product work
            </p>
            <h1 className="mb-4 bg-gradient-to-r from-pink-300 via-fuchsia-200 to-cyan-200 bg-clip-text text-4xl font-extrabold leading-tight text-transparent sm:text-6xl">
              {profile.name}
            </h1>
            <h2 className="mb-4 text-xl font-semibold text-cyan-200">{profile.title}</h2>
            <p className="max-w-3xl text-base leading-relaxed text-slate-200">{profile.summary}</p>
            <p className="mt-4 max-w-3xl rounded-xl border border-violet-300/20 bg-violet-500/10 p-3 text-sm text-violet-100">
              {profile.resumeNote}
            </p>
          </div>
          <div className="relative rounded-2xl border border-cyan-300/30 bg-slate-900/75 p-5 lg:w-1/4">
            <p className="text-xs uppercase tracking-wider text-cyan-200">Based in</p>
            <p className="mt-1 text-lg font-semibold text-white">{profile.location}</p>
            <p className="mt-4 text-xs uppercase tracking-wider text-pink-200">Contact</p>
            <a className="mt-1 block text-cyan-200 hover:text-cyan-100" href={`mailto:${profile.email}`}>
              {profile.email}
            </a>
            <p className="mt-1 text-slate-200">{profile.phone}</p>
            <div className="mt-4 rounded-lg bg-gradient-to-r from-emerald-500/20 to-teal-500/20 px-3 py-2 text-xs font-semibold text-emerald-100">
              Available for full-time and freelance projects
            </div>
          </div>
        </div>
        <div className="relative mb-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {highlights.map((highlight) => (
            <div
              key={highlight.label}
              className="rounded-xl border border-white/20 bg-slate-900/55 p-4 text-center backdrop-blur">
              <p className="text-2xl font-bold text-white">{highlight.value}</p>
              <p className="mt-1 text-xs uppercase tracking-wide text-slate-300">{highlight.label}</p>
            </div>
          ))}
        </div>
        <div className="relative flex flex-col gap-3 sm:flex-row">
          <a
            href="#contact"
            className="inline-flex items-center justify-center rounded-md bg-gradient-to-r from-pink-500 to-fuchsia-500 px-6 py-3 font-semibold text-white hover:from-pink-400 hover:to-fuchsia-400">
            Let&apos;s Build Together
          </a>
          <a
            href="#projects"
            className="inline-flex items-center justify-center rounded-md border border-cyan-400/50 bg-cyan-500/10 px-6 py-3 font-semibold text-cyan-100 hover:bg-cyan-500/20">
            View Experience
          </a>
          <a
            href={profile.resumeTextUrl}
            download
            className="inline-flex items-center justify-center rounded-md border border-violet-400/50 bg-violet-500/10 px-6 py-3 font-semibold text-violet-100 hover:bg-violet-500/20">
            Download Resume
          </a>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/About.js